import React from "react";
import { Link } from "react-router-dom";

function GasTerminal() {
  return (
    <>
      <style>{`
        .product-container {
          width: 100%;
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-wrap: wrap;
          background-color: #f0f0f0;
          padding: 20px;
          gap: 20px;
          box-sizing: border-box;
        }

        .product {
          width: 22%;
          height: 330px;
          border: 3px solid black;
          border-radius: 13px;
          background-color: white;
          overflow: hidden;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          animation: slideUpFade 0.6s ease-in-out;
        }

        .product:hover {
          transform: scale(1.03);
          box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);
        }

        .product img {
          width: 100%;
          height: 200px;
          object-fit: contain;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          background-color: #fff;
        }

        .product p {
          padding: 10px;
          text-align: center;
          font-size: 1.1rem;
          margin: 0;
          height: 80px;
        }

        .product button {
          width: 100%;
          padding: 10.23px;
          background-color: #007bff;
          color: white;
          border: none;
          border-radius: 0 0 10px 10px;
          cursor: pointer;
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          .product {
            width: 45%;
          }
        }

        @media (max-width: 480px) {
          .product {
            width: 100%;
          }
        }

        @keyframes slideUpFade {
          0% {
            transform: translateY(30px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>

      <div className="product-container">
        
        
        <div className="product">
          <img src="gt.png" alt="product1" />
          <p>Gas Outlet Point(PB Compatible)</p>
           <Link to="/gas-Outlet-Point">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="gt1.png" alt="product1" />
          <p>Gas Outlet (British Standard)</p>
           <Link to="/gas-Outlet">
            <button>View Details</button>
          </Link>
        </div>
        
       
       
    
       
        </div>
        
        
      
    </>
  );
}

export default GasTerminal;
